import { render, staticRenderFns } from "./bottomLeft2.vue?vue&type=template&id=564b8055&scoped=true&"
import script from "./bottomLeft2.vue?vue&type=script&lang=js&"
export * from "./bottomLeft2.vue?vue&type=script&lang=js&"
import style0 from "./bottomLeft2.vue?vue&type=style&index=0&id=564b8055&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b8055",
  null
  
)

export default component.exports